<!-- Loading Indicator -->
@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Header Section -->
<div
  class="relative bg-gradient-to-br from-slate-50 via-purple-50 to-indigo-50 shadow-xl border-b-4 border-purple-200 mb-6 overflow-hidden"
>
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500 rounded-full blur-3xl"
    ></div>
  </div>

  <div class="relative flex items-center justify-between px-8 py-3">
    <div class="flex items-center gap-3">
      <div
        class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-xl shadow-lg flex items-center justify-center"
      >
        <svg
          class="w-6 h-6 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          />
        </svg>
      </div>
      <div>
        <h1
          class="text-xl font-bold bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-600 bg-clip-text text-transparent mb-0"
        >
          Trip Schedule Wizard
        </h1>
        <p class="text-xs text-slate-500 mb-0">
          Create and manage vehicle trip schedules
        </p>
      </div>
    </div>
    <!-- Back Button - Header Top Right -->
    <button
      type="button"
      (click)="goBackToTripsDashboard()"
      class="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer"
    >
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 19l-7-7m0 0l7-7m-7 7h18"
        />
      </svg>
      <span>Back</span>
    </button>
  </div>
  <div
    class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-400 via-indigo-500 to-blue-500"
  ></div>
</div>

<div class="px-4 md:px-6">
  <!-- Filter Section -->
  <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-6">
    <div class="flex items-center gap-2 mb-4">
      <div
        class="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center"
      >
        <i
          nz-icon
          nzType="filter"
          nzTheme="outline"
          class="text-purple-600"
        ></i>
      </div>
      <h3 class="text-sm font-semibold text-slate-700 mb-0">Select Filters</h3>
    </div>

    <form nz-form [formGroup]="topfltrForm">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <!-- ULB Selection -->
        @if (!showLbl) {
        <div class="space-y-1">
          <label
            class="text-xs font-semibold text-slate-600 uppercase tracking-wide"
            >{{ lblNm }}</label
          >
          <nz-select
            nzShowSearch
            nzAllowClear
            [nzPlaceHolder]="'Select ' + lblNm"
            formControlName="tnt_id"
            (ngModelChange)="onTenantChange($event)"
            [(ngModel)]="tnt_id"
            class="w-full"
          >
            @for (t of tntLst; track t) {
            <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
            }
          </nz-select>
        </div>
        } @if (showLbl) {
        <div class="space-y-1">
          <label
            class="text-xs font-semibold text-slate-600 uppercase tracking-wide"
            >{{ lblNm }}</label
          >
          <div
            class="px-3 py-2 bg-slate-50 rounded-lg border border-slate-200 text-sm font-medium text-slate-800"
          >
            {{ tnt_nm }}
          </div>
        </div>
        }

        <!-- Trip Type -->
        <div class="space-y-1">
          <label
            class="text-xs font-semibold text-slate-600 uppercase tracking-wide"
            >Trip Type</label
          >
          <nz-select
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Trip Type"
            formControlName="trp_typ_id"
            (ngModelChange)="onTrpTypSelected($event)"
            [(ngModel)]="trp_typ_id"
            class="w-full"
          >
            @for (a of tripTypeLst; track a) {
            <nz-option
              [nzValue]="a.trp_typ_id"
              [nzLabel]="a.trp_typ_nm"
            ></nz-option>
            }
          </nz-select>
        </div>

        <!-- Sachivalayam -->
        @if (showSchvlym) {
        <div class="space-y-1">
          <label
            class="text-xs font-semibold text-slate-600 uppercase tracking-wide"
            >Sachivalayam</label
          >
          <nz-select
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Sachivalayam"
            formControlName="slctedSvm_id"
            (ngModelChange)="onsvmgetSelected($event)"
            [(ngModel)]="svm_id"
            class="w-full"
          >
            <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
            @for (a of svmLst; track a) {
            <nz-option [nzValue]="a.svm_id" [nzLabel]="a.svm_nm"></nz-option>
            }
          </nz-select>
        </div>
        }

        <!-- Vehicle -->
        <div class="space-y-1">
          <label
            class="text-xs font-semibold text-slate-600 uppercase tracking-wide"
            >Vehicle</label
          >
          <nz-select
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Vehicle"
            formControlName="slctedasrt"
            (ngModelChange)="onasrtgetSelected($event)"
            [(ngModel)]="asrt_id"
            class="w-full"
          >
            @for (a of vehclesLst; track a) {
            <nz-option [nzValue]="a.asrt_id" [nzLabel]="a.asrt_nm"></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Info Message -->
      <div
        class="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-100 flex items-start gap-2"
      >
        <i
          nz-icon
          nzType="info-circle"
          nzTheme="outline"
          class="text-blue-500 mt-0.5"
        ></i>
        @if (showSchvlym) {
        <p class="text-xs text-blue-700 mb-0">
          Please select Sachivalayam and Vehicle Registration Number for
          assigning Trips
        </p>
        } @if (!showSchvlym) {
        <p class="text-xs text-blue-700 mb-0">
          Please select Vehicle Registration Number for assigning Trips
        </p>
        }
      </div>
    </form>
  </div>

  <!-- Wizard Section -->
  <div
    class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-6"
  >
    <!-- Stepper Header -->
    <div
      class="p-4 bg-gradient-to-r from-slate-50 to-slate-100 border-b border-slate-200"
    >
      <div class="flex items-center justify-between flex-wrap gap-4">
        <!-- Step Indicators -->
        <div class="flex items-center gap-2">
          @for (step of [{num: 0, title: 'Instructions'}, {num: 1, title: 'Route
          Setup'}, {num: 2, title: 'Trip Config'}, {num: 3, title: 'Details'},
          {num: 4, title: 'Review'}]; track step; let i = $index) {
          <div class="flex items-center">
            <!-- Step Circle -->
            <div
              class="flex items-center gap-2 px-3 py-1.5 rounded-full transition-all duration-300"
              [class.bg-purple-600]="current === step.num"
              [class.text-white]="current === step.num"
              [class.bg-green-100]="current > step.num"
              [class.text-green-700]="current > step.num"
              [class.bg-slate-100]="current < step.num"
              [class.text-slate-400]="current < step.num"
            >
              <span
                class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                [class.bg-white]="current === step.num"
                [class.text-purple-600]="current === step.num"
                [class.bg-green-500]="current > step.num"
                [class.text-white]="current > step.num"
                [class.bg-slate-200]="current < step.num"
              >
                @if (current > step.num) {
                <i nz-icon nzType="check" nzTheme="outline"></i>
                } @if (current <= step.num) {
                <span>{{ step.num + 1 }}</span>
                }
              </span>
              <span class="text-xs font-semibold hidden md:inline">{{
                step.title
              }}</span>
            </div>
            <!-- Connector -->
            @if (i < 4) {
            <div
              class="w-8 h-0.5 mx-1"
              [class.bg-green-400]="current > step.num"
              [class.bg-slate-200]="current <= step.num"
            ></div>
            }
          </div>
          }
        </div>

        <!-- Navigation Buttons -->
        <div class="flex items-center gap-2">
          @if (current > 0 && isEdit==false && current!=4) {
          <button
            type="button"
            (click)="pre()"
            class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-all"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Previous
          </button>
          } @if (current==4) {
          <button
            type="button"
            (click)="pre()"
            class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-lg hover:bg-amber-100 transition-all"
          >
            <i nz-icon nzType="edit" nzTheme="outline"></i>
            Edit
          </button>
          } @if (current < 4) {
          <button
            type="button"
            (click)="next()"
            class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-purple-500 to-indigo-600 rounded-lg hover:from-purple-600 hover:to-indigo-700 shadow-md transition-all"
          >
            Next
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
          } @if (current === 4 && isEdit==false && shwTrp==true) {
          <button
            type="button"
            (click)="done()"
            class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg hover:from-green-600 hover:to-emerald-700 shadow-md transition-all"
          >
            <i nz-icon nzType="save" nzTheme="outline"></i>
            Save Schedule
          </button>
          }
        </div>
      </div>
    </div>

    <!-- Step Content -->
    <div class="p-6">
      <!-- Step 0: Instructions -->
      @if (index=='zero-content') {
      <div class="animate-fadeIn">
        <div class="text-center mb-6">
          <h2 class="text-lg font-bold text-slate-800 mb-2">
            How to Create a Route
          </h2>
          <p class="text-sm text-slate-500">
            Follow these simple steps to set up your vehicle trip schedule
          </p>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- Trip 1 Card -->
          <div
            class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-5 border border-green-100"
          >
            <div class="flex items-center gap-3 mb-4">
              <span
                class="w-10 h-10 rounded-full bg-green-500 text-white flex items-center justify-center font-bold"
                >1</span
              >
              <h3 class="text-base font-semibold text-green-800 mb-0">
                First Trip
              </h3>
            </div>
            <ul class="space-y-2 text-sm text-green-700">
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-green-500 mt-0.5"
                ></i>
                Starts at Vehicle Yard
              </li>
              @if (showSchvlym) {
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-green-500 mt-0.5"
                ></i>
                Goes to Sachivalayam/Micropocket for door-to-door collection
              </li>
              } @if (!showSchvlym) {
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-green-500 mt-0.5"
                ></i>
                Goes for door-to-door collection
              </li>
              }
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-green-500 mt-0.5"
                ></i>
                Goes to Transfer Point/Unloading point
              </li>
            </ul>
            <img
              class="w-full h-32 object-contain mt-4 rounded-lg"
              src="assets/images/primary-1.png"
              alt="Trip 1"
            />
          </div>
          <!-- Trip 2 Card -->
          <div
            class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-5 border border-blue-100"
          >
            <div class="flex items-center gap-3 mb-4">
              <span
                class="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold"
                >2</span
              >
              <h3 class="text-base font-semibold text-blue-800 mb-0">
                Intermediate Trips
              </h3>
            </div>
            <ul class="space-y-2 text-sm text-blue-700">
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-blue-500 mt-0.5"
                ></i>
                Starts at Transfer Point after unloading
              </li>
              @if (showSchvlym) {
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-blue-500 mt-0.5"
                ></i>
                Goes to Sachivalayam/Micropocket for collection
              </li>
              } @if (!showSchvlym) {
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-blue-500 mt-0.5"
                ></i>
                Goes for door-to-door collection
              </li>
              }
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-blue-500 mt-0.5"
                ></i>
                Returns to Transfer Point
              </li>
            </ul>
            <img
              class="w-full h-32 object-contain mt-4 rounded-lg"
              src="assets/images/primary-2.png"
              alt="Trip 2"
            />
          </div>
          <!-- Final Trip Card -->
          <div
            class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-5 border border-purple-100"
          >
            <div class="flex items-center gap-3 mb-4">
              <span
                class="w-10 h-10 rounded-full bg-purple-500 text-white flex items-center justify-center font-bold"
                >N</span
              >
              <h3 class="text-base font-semibold text-purple-800 mb-0">
                Final Trip
              </h3>
            </div>
            <ul class="space-y-2 text-sm text-purple-700">
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-purple-500 mt-0.5"
                ></i>
                Starts at Transfer Point after unloading
              </li>
              <li class="flex items-start gap-2">
                <i
                  nz-icon
                  nzType="check-circle"
                  nzTheme="fill"
                  class="text-purple-500 mt-0.5"
                ></i>
                Goes back to Vehicle Yard
              </li>
            </ul>
            <img
              class="w-full h-32 object-contain mt-4 rounded-lg"
              src="assets/images/primary-3.png"
              alt="Trip 3"
            />
          </div>
        </div>
      </div>
      }

      <!-- Step 1: Route Creation -->
      @if (index=='First-content') {
      <div class="animate-fadeIn">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <!-- Location Selection -->
          <div class="space-y-4">
            <h3
              class="text-base font-semibold text-slate-800 flex items-center gap-2"
            >
              <i
                nz-icon
                nzType="environment"
                nzTheme="outline"
                class="text-purple-500"
              ></i>
              Select Route Locations
            </h3>
            <form nz-form [formGroup]="tripFnceForm" class="space-y-4">
              <!-- Start Location -->
              <div class="bg-green-50 rounded-xl p-4 border border-green-100">
                <div class="flex items-center gap-3 mb-3">
                  <span
                    class="w-8 h-8 rounded-full bg-green-500 text-white flex items-center justify-center"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 10l7-7m0 0l7 7m-7-7v18"
                      />
                    </svg>
                  </span>
                  <div>
                    <label class="text-sm font-semibold text-green-800"
                      >Home Location / Vehicle Yard</label
                    >
                    <p class="text-xs text-green-600 mb-0">
                      Where the vehicle starts daily
                    </p>
                  </div>
                </div>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Select Home location / vehicle yard"
                  formControlName="strt_fnce_id"
                  (ngModelChange)="frmfnceSelected($event)"
                  class="w-full"
                >
                  @for (f of frmfnceFltrOptns; track f) {
                  <nz-option
                    [nzValue]="f.fnce_id"
                    [nzLabel]="f.fnce_nm"
                  ></nz-option>
                  }
                </nz-select>
                @if (frm_fnce_grp_nm) {
                <span class="text-xs text-green-600 mt-1 block">{{
                  frm_fnce_grp_nm
                }}</span>
                }
              </div>
              <!-- Arrow -->
              <div class="flex justify-center">
                <div
                  class="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center"
                >
                  <svg
                    class="w-5 h-5 text-slate-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 14l-7 7m0 0l-7-7m7 7V3"
                    />
                  </svg>
                </div>
              </div>
              <!-- End Location -->
              <div class="bg-red-50 rounded-xl p-4 border border-red-100">
                <div class="flex items-center gap-3 mb-3">
                  <span
                    class="w-8 h-8 rounded-full bg-red-500 text-white flex items-center justify-center"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 14l-7 7m0 0l-7-7m7 7V3"
                      />
                    </svg>
                  </span>
                  <div>
                    <label class="text-sm font-semibold text-red-800"
                      >Unloading Location</label
                    >
                    <p class="text-xs text-red-600 mb-0">
                      Where waste is discharged (Dump Yard/Transfer Station)
                    </p>
                  </div>
                </div>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Select Unloading location"
                  formControlName="end_fnce_id"
                  (ngModelChange)="endfnceSelected($event)"
                  class="w-full"
                >
                  @for (f of tofnceFltrOptns; track f) {
                  <nz-option
                    [nzValue]="f.fnce_id"
                    [nzLabel]="f.fnce_nm"
                  ></nz-option>
                  }
                </nz-select>
                @if (end_fnce_grp_nm) {
                <span class="text-xs text-red-600 mt-1 block">{{
                  end_fnce_grp_nm
                }}</span>
                }
              </div>
            </form>
            <!-- Add Location Link -->
            <div class="bg-amber-50 rounded-lg p-3 border border-amber-100">
              <p class="text-xs text-amber-700 mb-0">
                <a
                  (click)="opensideBar('addFncePanel', '')"
                  class="text-amber-600 hover:text-amber-800 font-semibold cursor-pointer underline"
                >
                  Click here
                </a>
                to add locations if your preferred location is not in the list.
              </p>
            </div>
            <!-- Info -->
            <div class="bg-slate-50 rounded-lg p-3 border border-slate-200">
              <p class="text-xs text-slate-600 mb-0 flex items-start gap-2">
                <i
                  nz-icon
                  nzType="info-circle"
                  nzTheme="outline"
                  class="text-slate-400 mt-0.5"
                ></i>
                A location is considered covered when the vehicle stays within
                40 meters radius.
              </p>
            </div>
          </div>
          <!-- Map -->
          <div
            class="bg-slate-50 rounded-xl overflow-hidden border border-slate-200"
          >
            <div id="map" class="w-full h-[450px]"></div>
          </div>
        </div>
      </div>
      }

      <!-- Step 2: Trip Configuration -->
      @if (index=='Second-content') {
      <div class="animate-fadeIn">
        @if (shwTrp==true) {
        <div>
          <h3
            class="text-base font-semibold text-slate-800 mb-4 flex items-center gap-2"
          >
            <i
              nz-icon
              nzType="schedule"
              nzTheme="outline"
              class="text-purple-500"
            ></i>
            Configure Trip Timings
          </h3>
          <form nz-form [formGroup]="routeForm">
            <div formArrayName="routes" class="space-y-4">
              @for (r of routeForm.get('routes').controls; track r; let i =
              $index) {
              <div
                [formGroupName]="i"
                class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden"
              >
                <!-- Trip Header -->
                <div
                  class="px-4 py-3 bg-gradient-to-r"
                  [class.from-green-50]="i == 0"
                  [class.to-emerald-50]="i == 0"
                  [class.from-purple-50]="
                    i == routeForm.get('routes').controls.length - 1
                  "
                  [class.to-pink-50]="
                    i == routeForm.get('routes').controls.length - 1
                  "
                  [class.from-blue-50]="
                    i > 0 && i < routeForm.get('routes').controls.length - 1
                  "
                  [class.to-indigo-50]="
                    i > 0 && i < routeForm.get('routes').controls.length - 1
                  "
                >
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-3">
                      <span
                        class="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm"
                        [class.bg-green-500]="i == 0"
                        [class.bg-purple-500]="
                          i == routeForm.get('routes').controls.length - 1
                        "
                        [class.bg-blue-500]="
                          i > 0 &&
                          i < routeForm.get('routes').controls.length - 1
                        "
                      >
                        {{ i + 1 }}
                      </span>
                      <div>
                        <p
                          class="text-sm font-semibold mb-0"
                          [class.text-green-800]="i == 0"
                          [class.text-purple-800]="
                            i == routeForm.get('routes').controls.length - 1
                          "
                          [class.text-blue-800]="
                            i > 0 &&
                            i < routeForm.get('routes').controls.length - 1
                          "
                        >
                          @if (i==0) {
                          <span>First Trip - Vehicle Yard to Collection</span>
                          } @if (i== routeForm.get('routes').controls.length-1)
                          {
                          <span>Final Trip - Return to Home</span>
                          } @if (i>0 && i <
                          routeForm.get('routes').controls.length-1) {
                          <span>Intermediate Trip {{ i }}</span>
                          }
                        </p>
                      </div>
                    </div>
                    <div class="flex items-center gap-2">
                      @if (i < routeForm.get('routes').controls.length-1 && i>0)
                      {
                      <button
                        type="button"
                        (click)="addRoute(i, routeForm.controls.routes)"
                        class="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded hover:bg-green-200 transition"
                      >
                        <i nz-icon nzType="plus" nzTheme="outline"></i> Add Trip
                      </button>
                      } @if (i>1 && i <
                      routeForm.get('routes').controls.length-1) {
                      <button
                        type="button"
                        (click)="deleteRoute(routeForm.controls.routes, i)"
                        class="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-red-700 bg-red-100 rounded hover:bg-red-200 transition"
                      >
                        <i nz-icon nzType="delete" nzTheme="outline"></i> Delete
                      </button>
                      }
                    </div>
                  </div>
                </div>
                <!-- Trip Content -->
                <div class="p-4">
                  <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >Start Location</label
                      >
                      <nz-select
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="Start Location"
                        formControlName="strt_fnce_id"
                        nzDisabled
                        class="w-full"
                      >
                        @for (f of fnceFltrOptns; track f) {
                        <nz-option
                          [nzValue]="f.fnce_id"
                          [nzLabel]="f.fnce_nm"
                        ></nz-option>
                        }
                      </nz-select>
                    </div>
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >End Location</label
                      >
                      <nz-select
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="End Location"
                        formControlName="end_fnce_id"
                        nzDisabled
                        class="w-full"
                      >
                        @for (f of fnceFltrOptns; track f) {
                        <nz-option
                          [nzValue]="f.fnce_id"
                          [nzLabel]="f.fnce_nm"
                        ></nz-option>
                        }
                      </nz-select>
                    </div>
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >Start Time</label
                      >
                      <nz-time-picker
                        formControlName="arvl_ts"
                        [nzFormat]="timeFormat"
                        (ngModelChange)="strtedtime($event, i)"
                        [nzDisabled]="isEdit == true"
                        class="w-full"
                      ></nz-time-picker>
                    </div>
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >End Time</label
                      >
                      <nz-time-picker
                        formControlName="dprtr_ts"
                        [nzFormat]="timeFormat"
                        (ngModelChange)="endtime($event, i)"
                        [nzDisabled]="isEdit == true"
                        class="w-full"
                      ></nz-time-picker>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </form>
          <!-- Help Text -->
          <div class="mt-4 flex flex-wrap gap-4 text-xs text-slate-500">
            <span class="flex items-center gap-1">
              <i
                nz-icon
                nzType="plus-square"
                nzTheme="outline"
                class="text-green-500"
              ></i>
              Click to <strong>Add</strong> intermediate trip
            </span>
            <span class="flex items-center gap-1">
              <i
                nz-icon
                nzType="delete"
                nzTheme="outline"
                class="text-red-500"
              ></i>
              Click to <strong>Delete</strong> intermediate trip
            </span>
          </div>
        </div>
        } @if (shwTrp==false) {
        <div class="text-center py-12">
          <div
            class="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4"
          >
            <i
              nz-icon
              nzType="warning"
              nzTheme="outline"
              class="text-2xl text-amber-500"
            ></i>
          </div>
          <h3 class="text-lg font-semibold text-slate-700 mb-2">
            No Route Selected
          </h3>
          <p class="text-sm text-slate-500">
            Please go back and select Home location and Unloading location
            first.
          </p>
        </div>
        }
      </div>
      }

      <!-- Step 3: Assign Timings / Edit -->
      @if (index=='third-content') {
      <div class="animate-fadeIn">
        @if (shwTrp==true) {
        <div>
          <h3
            class="text-base font-semibold text-slate-800 mb-4 flex items-center gap-2"
          >
            <i
              nz-icon
              nzType="edit"
              nzTheme="outline"
              class="text-purple-500"
            ></i>
            Edit Trip Details & Intermediate Locations
          </h3>
          <form nz-form [formGroup]="routeForm">
            <div formArrayName="routes" class="space-y-4">
              @for (r of routeForm.get('routes').controls; track r; let i =
              $index) {
              <div
                [formGroupName]="i"
                class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden"
              >
                <!-- Trip Header -->
                <div
                  class="px-4 py-3 bg-gradient-to-r from-slate-50 to-slate-100 border-b border-slate-200"
                >
                  <div class="flex items-center justify-between">
                    <h4
                      class="text-sm font-semibold text-slate-700 mb-0 flex items-center gap-2"
                    >
                      <span
                        class="w-6 h-6 rounded-full bg-purple-500 text-white flex items-center justify-center text-xs font-bold"
                        >{{ i + 1 }}</span
                      >
                      Trip {{ i + 1 }}
                    </h4>
                    @if (isEdit==true) {
                    <div class="flex items-center gap-2">
                      <button
                        type="button"
                        (click)="showIpForm(routeForm.controls.routes, i, i)"
                        class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-purple-700 bg-purple-100 rounded-lg hover:bg-purple-200 transition"
                      >
                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                        Intermediate Locations
                      </button>
                      <button
                        type="button"
                        (click)="
                          showConfirmDelete(i, routeForm.controls.routes)
                        "
                        class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-red-700 bg-red-100 rounded-lg hover:bg-red-200 transition"
                      >
                        <i nz-icon nzType="delete" nzTheme="outline"></i> Delete
                        Trip
                      </button>
                    </div>
                    }
                  </div>
                </div>
                <!-- Trip Details -->
                <div class="p-4">
                  <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <!-- Start Location -->
                    @if (isEdit==false) {
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >Start Location</label
                      >
                      <nz-select
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="Start Location"
                        formControlName="strt_fnce_id"
                        (ngModelChange)="svmStrtfnceSelected($event, i)"
                        nzDisabled
                        class="w-full"
                      >
                        @for (f of fnceFltrOptns; track f) {
                        <nz-option
                          [nzValue]="f.fnce_id"
                          [nzLabel]="f.fnce_nm"
                        ></nz-option>
                        }
                      </nz-select>
                    </div>
                    } @if (isEdit==true) {
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >Start Location</label
                      >
                      <div
                        class="px-3 py-2 bg-slate-50 rounded-lg text-sm text-slate-700"
                      >
                        {{ r.value.strt_fnce_nm }}
                      </div>
                    </div>
                    }
                    <!-- End Location -->
                    @if (isEdit==false) {
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >End Location</label
                      >
                      @if (i < routeForm.get('routes').controls.length-1) {
                      <nz-select
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="Select Stop"
                        formControlName="end_fnce_id"
                        (ngModelChange)="
                          svmEndfnceSelected(
                            $event,
                            i,
                            routeForm.controls.routes
                          )
                        "
                        [nzDisabled]="isEdit == true"
                        class="w-full"
                      >
                        @for (f of fnceFltrOptns; track f) {
                        <nz-option
                          [nzValue]="f.fnce_id"
                          [nzLabel]="f.fnce_nm"
                        ></nz-option>
                        }
                      </nz-select>
                      } @if (i == routeForm.get('routes').controls.length-1) {
                      <nz-select
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="Select Stop"
                        formControlName="end_fnce_id"
                        (ngModelChange)="
                          svmEndfnceSelected(
                            $event,
                            i,
                            routeForm.controls.routes
                          )
                        "
                        nzDisabled
                        class="w-full"
                      >
                        @for (f of fnceFltrOptns; track f) {
                        <nz-option
                          [nzValue]="f.fnce_id"
                          [nzLabel]="f.fnce_nm"
                        ></nz-option>
                        }
                      </nz-select>
                      }
                    </div>
                    } @if (isEdit==true) {
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >End Location</label
                      >
                      <div
                        class="px-3 py-2 bg-slate-50 rounded-lg text-sm text-slate-700"
                      >
                        {{ r.value.end_fnce_nm }}
                      </div>
                    </div>
                    }
                    <!-- Start Time -->
                    @if (isEdit==false) {
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >Start Time</label
                      >
                      <nz-time-picker
                        formControlName="arvl_ts"
                        [nzFormat]="timeFormat"
                        (ngModelChange)="strtedtime($event, i)"
                        nzDisabled
                        class="w-full"
                      ></nz-time-picker>
                    </div>
                    } @if (isEdit==true) {
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >Start Time</label
                      >
                      <div
                        class="flex items-center gap-2"
                        [hidden]="r.value.shwEdtStrt == true"
                      >
                        <div
                          class="px-3 py-2 bg-slate-50 rounded-lg text-sm text-slate-700 flex-1"
                        >
                          {{ r.value.arvl_ts | date : "HH:mm" }}
                        </div>
                        <button
                          type="button"
                          (click)="showStrtEdit(i, routeForm.controls.routes)"
                          class="w-8 h-8 flex items-center justify-center rounded-lg bg-blue-100 text-blue-600 hover:bg-blue-200 transition"
                        >
                          <i
                            nz-icon
                            nzType="edit"
                            nzTheme="outline"
                            class="text-sm"
                          ></i>
                        </button>
                      </div>
                      <nz-time-picker
                        [hidden]="r.value.shwEdtStrt == false"
                        formControlName="arvl_ts"
                        [nzFormat]="timeFormat"
                        (ngModelChange)="
                          edtstrtedtime($event, i, routeForm.controls.routes)
                        "
                        class="w-full"
                      ></nz-time-picker>
                    </div>
                    }
                    <!-- End Time -->
                    @if (isEdit==false) {
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >End Time</label
                      >
                      <nz-time-picker
                        formControlName="dprtr_ts"
                        [nzFormat]="timeFormat"
                        (ngModelChange)="endtime($event, i)"
                        nzDisabled
                        class="w-full"
                      ></nz-time-picker>
                    </div>
                    } @if (isEdit==true) {
                    <div class="space-y-1">
                      <label
                        class="text-xs font-semibold text-slate-500 uppercase"
                        >End Time</label
                      >
                      <div
                        class="flex items-center gap-2"
                        [hidden]="r.value.shwEdtEnd == true"
                      >
                        <div
                          class="px-3 py-2 bg-slate-50 rounded-lg text-sm text-slate-700 flex-1"
                        >
                          {{ r.value.dprtr_ts | date : "HH:mm" }}
                        </div>
                        <button
                          type="button"
                          (click)="showEndEdit(i, routeForm.controls.routes)"
                          class="w-8 h-8 flex items-center justify-center rounded-lg bg-blue-100 text-blue-600 hover:bg-blue-200 transition"
                        >
                          <i
                            nz-icon
                            nzType="edit"
                            nzTheme="outline"
                            class="text-sm"
                          ></i>
                        </button>
                      </div>
                      <nz-time-picker
                        [hidden]="r.value.shwEdtEnd == false"
                        formControlName="dprtr_ts"
                        [nzFormat]="timeFormat"
                        (ngModelChange)="
                          edtEndtime($event, i, routeForm.controls.routes)
                        "
                        class="w-full"
                      ></nz-time-picker>
                    </div>
                    }
                  </div>
                  <!-- Intermediate Locations (Edit Mode) -->
                  @if (isEdit==true) {
                  <div
                    [hidden]="r.value.shwIpadd == false"
                    class="mt-4 p-4 bg-purple-50 rounded-xl border border-purple-100"
                  >
                    <h5
                      class="text-sm font-semibold text-purple-800 mb-3 flex items-center gap-2"
                    >
                      <i nz-icon nzType="environment" nzTheme="outline"></i>
                      Intermediate Locations
                    </h5>
                    <div formArrayName="points" class="space-y-3">
                      @for (point of r.get('points').controls; track point; let
                      j = $index) {
                      <div [formGroupName]="j">
                        <div class="flex items-center gap-3">
                          <span
                            class="w-6 h-6 rounded-full bg-purple-200 text-purple-700 flex items-center justify-center text-xs font-semibold"
                            >{{ j + 1 }}</span
                          >
                          <nz-select
                            nzShowSearch
                            nzAllowClear
                            nzPlaceHolder="Select Intermediate Location"
                            formControlName="ip_fnce_id"
                            (ngModelChange)="
                              onIpSelected($event, j, r.controls.points)
                            "
                            class="flex-1"
                          >
                            @for (f of interfnceFltrOptns; track f) {
                            <nz-option
                              [nzValue]="f.fnce_id"
                              [nzLabel]="f.fnce_nm"
                            ></nz-option>
                            }
                          </nz-select>
                          @if (j>=0) {
                          <button
                            type="button"
                            (click)="addIpinRoute(j, r.controls.points)"
                            class="w-8 h-8 flex items-center justify-center rounded-lg bg-green-100 text-green-600 hover:bg-green-200 transition"
                          >
                            <i nz-icon nzType="plus" nzTheme="outline"></i>
                          </button>
                          } @if (j>=0) {
                          <button
                            type="button"
                            (click)="deleteIpinRoute(r.controls.points, j)"
                            class="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 text-red-600 hover:bg-red-200 transition"
                          >
                            <i nz-icon nzType="delete" nzTheme="outline"></i>
                          </button>
                          }
                        </div>
                      </div>
                      }
                    </div>
                    <div class="mt-4 flex justify-center">
                      <button
                        type="button"
                        (click)="saveIps(r.controls.points, r.controls)"
                        class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 transition"
                      >
                        <i nz-icon nzType="save" nzTheme="outline"></i>
                        Update Intermediate Locations
                      </button>
                    </div>
                  </div>
                  }
                  <!-- Intermediate Locations (Create Mode) -->
                  @if (isEdit==false) {
                  <div
                    class="mt-4 p-4 bg-slate-50 rounded-xl border border-slate-200"
                  >
                    <h5
                      class="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2"
                    >
                      <i nz-icon nzType="environment" nzTheme="outline"></i>
                      Intermediate Locations
                    </h5>
                    <div formArrayName="points" class="space-y-3">
                      @for (point of r.get('points').controls; track point; let
                      j = $index) {
                      <div [formGroupName]="j">
                        <div class="flex items-center gap-3">
                          <span
                            class="w-6 h-6 rounded-full bg-slate-200 text-slate-700 flex items-center justify-center text-xs font-semibold"
                            >{{ j + 1 }}</span
                          >
                          <nz-select
                            nzShowSearch
                            nzAllowClear
                            nzPlaceHolder="Select Intermediate Location"
                            formControlName="ip_fnce_id"
                            (ngModelChange)="
                              onIpSelected($event, j, r.controls.points)
                            "
                            class="flex-1"
                          >
                            @for (f of interfnceFltrOptns; track f) {
                            <nz-option
                              [nzValue]="f.fnce_id"
                              [nzLabel]="f.fnce_nm"
                            ></nz-option>
                            }
                          </nz-select>
                          @if (j>=0) {
                          <button
                            type="button"
                            (click)="addIpinRoute(j, r.controls.points)"
                            class="w-8 h-8 flex items-center justify-center rounded-lg bg-green-100 text-green-600 hover:bg-green-200 transition"
                          >
                            <i nz-icon nzType="plus" nzTheme="outline"></i>
                          </button>
                          } @if (j>=0) {
                          <button
                            type="button"
                            (click)="deleteIpinRoute(r.controls.points, j)"
                            class="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 text-red-600 hover:bg-red-200 transition"
                          >
                            <i nz-icon nzType="delete" nzTheme="outline"></i>
                          </button>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </form>
        </div>
        } @if (shwTrp==false) {
        <div class="text-center py-12">
          <div
            class="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4"
          >
            <i
              nz-icon
              nzType="warning"
              nzTheme="outline"
              class="text-2xl text-amber-500"
            ></i>
          </div>
          <h3 class="text-lg font-semibold text-slate-700 mb-2">
            No Route Selected
          </h3>
          <p class="text-sm text-slate-500">
            Please select Home location and Unloading location first.
          </p>
        </div>
        }
      </div>
      }

      <!-- Step 4: Review -->
      @if (index=='fourth-content') {
      <div class="animate-fadeIn">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <!-- Data Grid -->
          <div
            class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden"
          >
            <div
              class="px-4 py-3 bg-gradient-to-r from-slate-50 to-slate-100 border-b border-slate-200"
            >
              <h3
                class="text-sm font-semibold text-slate-700 mb-0 flex items-center gap-2"
              >
                <i
                  nz-icon
                  nzType="table"
                  nzTheme="outline"
                  class="text-purple-500"
                ></i>
                Trip Summary
              </h3>
            </div>
            <div class="p-4">
              <app-data-grid
                id="gridContainer"
                style="width: 100%"
                [dataSource]="tableData"
                [legacyColumns]="columnDefs"
                [searchPanel]="true"
                [filterRow]="true"
                [filterPanel]="true"
                [groupPanel]="true"
                [columnChooser]="true"
                [allowExport]="true"
                exportFileName="Trip Schedule"
                [pageSize]="10"
                [allowedPageSizes]="[10, 25, 50, 100]"
                [showPageSizeSelector]="true"
                [rowAlternationEnabled]="true"
                [showBorders]="true"
                [wordWrapEnabled]="true"
                [masterDetail]="true"
              >
                <app-grid-column
                  [visible]="true"
                  type="buttons"
                  [width]="100"
                  caption="View"
                  cellTemplate="viewTemplate"
                ></app-grid-column>
                <ng-template appGridCell="viewTemplate" let-data="cell"
                  ><div>
                    <button
                      (click)="viewMap(data)"
                      class="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded hover:bg-blue-200 transition"
                    >
                      <i nz-icon nzType="environment" nzTheme="outline"></i> Map
                    </button>
                  </div></ng-template
                >
                <ng-template appGridDetail let-entCust="cell"
                  ><div>
                    <app-data-grid
                      id="gridContainer"
                      style="width: 100%"
                      [dataSource]="entCust.data.points"
                      [legacyColumns]="columnDefs2"
                      [searchPanel]="false"
                      [filterRow]="false"
                      [filterPanel]="false"
                      [groupPanel]="false"
                      [columnChooser]="false"
                      [allowExport]="false"
                      [pageSize]="10"
                      [wordWrapEnabled]="true"
                    >
                    </app-data-grid></div
                ></ng-template>
              </app-data-grid>
            </div>
          </div>
          <!-- Map -->
          <div
            class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden"
          >
            <div
              class="px-4 py-3 bg-gradient-to-r from-slate-50 to-slate-100 border-b border-slate-200"
            >
              <h3
                class="text-sm font-semibold text-slate-700 mb-0 flex items-center gap-2"
              >
                <i
                  nz-icon
                  nzType="environment"
                  nzTheme="outline"
                  class="text-purple-500"
                ></i>
                Route Map
              </h3>
            </div>
            <div id="map2" class="w-full h-[450px]"></div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<!-- Add Location Slide-Over Panel -->
@if (opnSdebar && ShowAddFnce) {
<div class="fixed inset-0 z-50 overflow-hidden animate-fadeIn">
  <!-- Backdrop -->
  <div
    class="absolute inset-0 bg-gray-900 bg-opacity-50 backdrop-blur-sm transition-opacity"
    (click)="closeSider()"
  ></div>
  <!-- Slide-over panel -->
  <div class="fixed inset-y-0 right-0 flex max-w-full pl-10 animate-slideIn">
    <div
      class="w-screen max-w-lg transform transition-transform duration-300 ease-in-out"
    >
      <div
        class="flex h-full flex-col bg-white shadow-2xl rounded-l-2xl overflow-hidden"
      >
        <!-- Header with Close Button -->
        <div class="bg-gradient-to-r from-purple-600 to-indigo-600 px-6 py-4">
          <div class="flex items-center justify-between">
            <h2
              class="text-lg font-semibold text-white flex items-center gap-3"
            >
              <div
                class="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center"
              >
                <i
                  nz-icon
                  nzType="environment"
                  nzTheme="outline"
                  class="text-white text-lg"
                ></i>
              </div>
              <div>
                <span class="block">Add Location</span>
                <span class="block text-xs text-purple-200 font-normal"
                  >Create a new location point</span
                >
              </div>
            </h2>
            <!-- Close Button - Top Right -->
            <button
              type="button"
              (click)="closeSider()"
              class="w-10 h-10 rounded-xl bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/50"
            >
              <svg
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <!-- Content -->
        <div class="flex-1 overflow-y-auto px-6 py-6 bg-slate-50">
          @if (tnt_id) {
          <app-location-add [tntId]="selctdtenant"></app-location-add>
          }
        </div>
        <!-- Footer -->
        <div class="px-6 py-4 bg-white border-t border-slate-200">
          <button
            type="button"
            (click)="closeSider()"
            class="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-lg transition-all"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            Close Panel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}
